module.exports = __webpack_public_path__ + "img/AN_rc_8.95c4fbb7.png";